<style lang="scss" scoped>
@import '$vars';

.medical-history-anamnesis {
  @apply w-full;
  margin-bottom: 2px;

  &__wrapper {
    @apply flex flex-row flex-wrap items-center justify-start;
    @apply w-full p-2;
  }

  &__question {
    @apply w-1/2 m-0 p-0 mb-2;

    @screen mobile {
      @apply w-full;
    }

    &-title {
      @apply p-0 m-0;
      @apply text-grayMedium;
      font-family: $font1;
      font-size: 0.7rem;
      font-weight: 600;
    }

    &-answer {
      @apply m-0 p-0;
      @apply text-grayDark;
      font-family: $font1;
      font-size: 0.7rem;
    }
  }
}

.medical-history-section {
  @apply flex flex-col items-center content-start justify-start;
  @apply w-full;
  margin-bottom: 2px;

  &__header {
    @apply flex flex-row items-center justify-between;
    @apply w-full p-2;
    @apply cursor-pointer;
    background: rgb(236, 240, 241);
  }

  &__title {
    @apply m-0 p-0;
    @apply text-grayDark;
    font-family: $font1;
    font-size: 0.8rem;
    font-weight: 600;
  }

  &__content {
    @apply w-full p-2;
  }

  &__icon {
    transition: all 0.3s ease;

    &--up {
      transform: rotate(180deg);
      transition: all 0.3s ease;
    }
  }
}
</style>

<template>
  <section class="medical-history-anamnesis">
    <header
      class="medical-history-section__header"
      @click="ui.isOpen = !ui.isOpen"
    >
      <h2 class="medical-history-section__title">
        Anamnese - {{ isCustomized ? anamnesis.name : 'Padrão' }}
      </h2>

      <i
        :class="{ 'medical-history-section__icon--up': ui.isOpen }"
        class="icon icon-arrow-down medical-history-section__icon"
      />
    </header>

    <div
      v-if="ui.isOpen"
      class="medical-history-anamnesis__wrapper"
    >
      <div
        v-for="(question, index) in questions"
        :key="`medical-history-anamnesis-question-${index}`"
        class="medical-history-anamnesis__question"
      >
        <h4 class="medical-history-anamnesis__question-title">
          {{ isCustomized ?  question.name : question.title }}
        </h4>

        <p class="medical-history-anamnesis__question-answer">
          {{ question.value }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MedicalHistoryAnamnesis',

  props: {
    anamnesis: {
      type: [Array, Object],
      required: true
    },

    isCustomized: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      ui: {
        isOpen: false
      }
    }
  },

  computed: {
    questions () {
      if (this.isCustomized) {
        return this.anamnesis.questions
      }

      return this.anamnesis
    }
  }
}
</script>
